<template>
  <div class="heading-block primary white--text">{{ heading }}</div>
</template>

<style lang="scss" scoped>
.heading-block {
  display: block;
  width: 100%;
  padding: 0.5rem 0;

  font-size: 2.25rem;
  text-align: center;
}
</style>

<script>
export default {
  name: "HeadingBlock",
  components: {},
  props: ["heading"]
};
</script>
